import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import FakeNotification from '../FakeNotification';
import s from './FakeDrawer.scss';
const FakeDrawer = ({ showBetaLabel =true  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['drawer-header']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t('siteHeader.anonFakeNotifications.drawer.title'), showBetaLabel && /*#__PURE__*/ React.createElement("span", {
        className: s['beta']
    }, "BETA")), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        href: Url.joinLink(),
        className: s['see-all']
    }, t('siteHeader.anonFakeNotifications.drawer.seeAll'))), /*#__PURE__*/ React.createElement(FakeNotification, null));
};
FakeDrawer.displayName = 'FakeDrawer';
export default FakeDrawer;
